import Ajv from 'ajv';
import Joi from 'joi';

const ajv = new Ajv();

//@todo - rename to dataGridResponse
const dataGridFromApiSchema = Joi.object({
  ID: Joi.number().required(),
  Name: Joi.string().required(),
  Slug: Joi.string().required(),
  Data: Joi.array().required(),
  Schema: Joi.object().required(),
  UpdatedAt: Joi.date(),
  CreatedAt: Joi.date(),
});

const getIngestJobStatusResponse = Joi.object({
  ID: Joi.number().required(),
  Status: Joi.string().allow(''), // @todo need to be required
  FileName: Joi.string(),
  Message: Joi.string().allow(''),
  Progress: Joi.number().optional(),
  UpdatedAt: Joi.date(),
  CreatedAt: Joi.date(),
  DeletedAt: Joi.date().optional().allow(null),
});

export const joiSchemaValidators = {
  DATA_GRID_FROM_API: dataGridFromApiSchema,
  INGEST_JOB_STATUS_RESPONSE: getIngestJobStatusResponse,
};

export const validateDataWithJoi = ({
  actionName,
  data,
  joiSchema,
  validateJsonSchema = false,
}: {
  data: any;
  actionName: string;
  joiSchema: Joi.Schema;
  validateJsonSchema?: boolean;
}) => {
  const { error } = joiSchema.validate(data);

  if (error) {
    throw new Error(`Validation failed for: ${actionName}. Message: ${error.message}`);
  }

  if (validateJsonSchema) {
    // Validate the Schema property with AJV to ensure it meets JSON schema standards
    const isSchemaValid = ajv.validateSchema(data.Schema);

    if (!isSchemaValid) {
      throw new Error(`Invalid Schema format for ${actionName}`);
    }
  }

  return data;
};
